declare namespace $ {

	type $mol_check_icon__hint_shm_hitalama_skills_editor_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__enabled_shm_hitalama_skills_editor_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['editable'] >
		,
		ReturnType< $mol_check_icon['enabled'] >
	>
	type $mol_check_icon__checked_shm_hitalama_skills_editor_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['editor_open'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_skills_editor_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['Edit_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_link__hint_shm_hitalama_skills_editor_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['hint'] >
	>
	type $mol_link__arg_shm_hitalama_skills_editor_6 = $mol_type_enforce<
		({ 
			'skill': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_shm_hitalama_skills_editor_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_labeler__title_shm_hitalama_skills_editor_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_skills_editor_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['name_content'] >
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_shm_hitalama_skills_editor_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_skills_editor_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['id_content'] >
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_shm_hitalama_skills_editor_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_skills_editor_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['description_content'] >
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_shm_hitalama_skills_editor_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_skills_editor_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['instruction_content'] >
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string__enabled_shm_hitalama_skills_editor_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['editable'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__value_shm_hitalama_skills_editor_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['entry_title'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__enabled_shm_hitalama_skills_editor_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['editable'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__value_shm_hitalama_skills_editor_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['skill_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_textarea__enabled_shm_hitalama_skills_editor_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['editable'] >
		,
		ReturnType< $mol_textarea['enabled'] >
	>
	type $mol_textarea__value_shm_hitalama_skills_editor_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['description'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__enabled_shm_hitalama_skills_editor_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['editable'] >
		,
		ReturnType< $mol_textarea['enabled'] >
	>
	type $mol_textarea__value_shm_hitalama_skills_editor_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['instruction'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_text__text_shm_hitalama_skills_editor_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['description'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_hitalama_skills_editor_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['instruction'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_status__status_shm_hitalama_skills_editor_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['status'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $shm_hitalama_skills_source__entry_shm_hitalama_skills_editor_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['entry'] >
		,
		ReturnType< $shm_hitalama_skills_source['entry'] >
	>
	type $shm_hitalama_skills_source__path_shm_hitalama_skills_editor_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['identity'] >
		,
		ReturnType< $shm_hitalama_skills_source['path'] >
	>
	type $shm_hitalama_skills_source__enabled_shm_hitalama_skills_editor_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_editor['editable'] >
		,
		ReturnType< $shm_hitalama_skills_source['enabled'] >
	>
	export class $shm_hitalama_skills_editor extends $mol_page {
		editing( next?: boolean ): boolean
		editable( ): boolean
		editor_open( next?: boolean ): boolean
		Edit_icon( ): $mol_icon_pencil
		Edit( ): $mol_check_icon
		Close_icon( ): $mol_icon_close
		Close( ): $mol_link
		name_content( ): readonly($mol_view_content)[]
		Name( ): $mol_labeler
		id_content( ): readonly($mol_view_content)[]
		Skill_name( ): $mol_labeler
		description_content( ): readonly($mol_view_content)[]
		Description( ): $mol_labeler
		instruction_content( ): readonly($mol_view_content)[]
		Instruction( ): $mol_labeler
		entry_title( next?: string ): string
		skill_name( next?: string ): string
		description( next?: string ): string
		instruction( next?: string ): string
		status( ): string
		identity( id: any): string
		entry( ): $shm_hitalama_skills_entry
		minimal_width( ): number
		attr( ): ({ 
			'editing': ReturnType< $shm_hitalama_skills_editor['editing'] >,
		})  & ReturnType< $mol_page['attr'] >
		title( ): string
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		Name_input( ): $mol_string
		Skill_name_input( ): $mol_string
		Description_input( ): $mol_textarea
		Instruction_input( ): $mol_textarea
		Description_text( ): $mol_text
		Instruction_text( ): $mol_text
		Status( ): $mol_status
		Source( id: any): $shm_hitalama_skills_source
	}
	
}

//# sourceMappingURL=editor.view.tree.d.ts.map